package one.healthium.today.ui.fodmap

import one.healthium.domain.user.UserModel
import one.healthium.healthKit.data.HealthKitStatus
import one.healthium.tasks.domain.DailyTaskModel
import one.healthium.tasks.ui.DailyTasksUiModel
import androidx.compose.runtime.Immutable

@Immutable
internal data class TodayUiState(
    val loading: Boolean = false,
    val user: UserModel? = null,
    val tasks: List<DailyTaskModel>? = null,
    val healthKitStatus: HealthKitStatus? = null,
) {
    val tasksUiModel = DailyTasksUiModel(tasks)
    val todayCalendarUiModel = TodayCalendarUiModel(user?.profile?.name ?: "")
    val shouldShowHKBanner = healthKitStatus == HealthKitStatus.UNKNOWN
}
